__webpack_require__.p = "/Urimu-Cafe/";